import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { LaunchDialogService } from '@spartacus/storefront'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-saved-quote-cart-dialog',
  templateUrl: './saved-quote-cart-dialog.component.html',
  styleUrls: ['./saved-quote-cart-dialog.component.scss'],
})
export class SavedQuoteCartDialogComponent implements OnInit {
  modalIsOpen = false
  cartName = ''
  cartDescription = ''
  nameErrorMessage = ''
  duplicateErrorMessage = ''
  showCartError = false
  showDuplicateCartErr = false

  currentUser

  currentCart: any = null

  @ViewChild('dialog', { read: ElementRef })
  dialog: ElementRef

  createSavedCartForm = this.fb.group({
    description: [''],
    cartName: ['', Validators.required],
  })
  dataSource = []

  constructor(
    private launchDialogService: LaunchDialogService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.launchDialogService.data$.subscribe((data) => {
      this.currentCart = data.currentCart
    })
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.SAVED_QUOTE_CART,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }

  closeModal(createSavedCartForm) {
    this.nameErrorMessage = ''
    if (!this.cartName.trim().length) {
      this.showDuplicateCartErr = false
      this.showCartError = true
      this.nameErrorMessage = 'Please enter cart name'
      return
    }
    if (this.createSavedCartForm.valid) {
      const dialogResponse: DialogResponse = {
        type: VS_LAUNCH_CALLER.SAVED_QUOTE_CART,
        reason: 'CART saved',
        data: createSavedCartForm,
      }
      this.launchDialogService.closeDialog(dialogResponse)
    }
  }
}
